import * as Yup from 'yup'

const Validation = Yup.object({
  languageTaxonomyId: Yup.string().required('Language is required'),
  languageLevelId: Yup.string().required('Language level is required'),
})

export default Validation
